// extracted by mini-css-extract-plugin
export default {"wrapper":"SlideTitle_wrapper_ZTswK","title":"SlideTitle_title_USinL"};